import VueRouter from 'vue-router'
import Vue from 'vue'
import myHome from "@/views/zhicai/myHome.vue"
import myApp from "@/views/zhicai/myApp.vue"
import zoneApp from "@/views/procurementZone/zoneApp.vue";
// 防止重复点击路由，导致提示避免到当前位置的冗余导航（路由冗余）解决方式
const routerRePush = VueRouter.prototype.push
VueRouter.prototype.push = function (location) {
    return routerRePush.call(this, location).catch(error => error)
}
// 通过vue.use(插件)，安装插件
Vue.use(VueRouter)
// 创建路由对象
const routes = [
    {path: '/', component: myApp,
        children:[
            {path: '/home', name: "MyHome", component: myHome, meta: {title: '国资智采-电子招投标采购平台-中国招标采购网-政府招标项目公告 - 国资智采'}},
            {path: '/about', name: "myAbout", component: () => import("@/views/zhicai/myAbout.vue"), meta: {title: '交易信息-国资智采'}},
            {path: '/download', name: "Download", component: () => import("@/views/zhicai/myDownload.vue"), meta: {title: '下载中心-国资智采'}},
            {path: '/myExpert', name: "Expert", component: () => import("@/views/zhicai/myExpert.vue"), meta: {title: '平台专家库-国资智采'}},
            {path: '/ggDetail', name: "ggDetail", component: () => import("@/views/zhicai/ggDetail.vue"), meta: {title: '交易信息-详情-国资智采'}},
            {path: '/newsDetail', name: "newsDetail", component: () => import("@/views/zhicai/newsDetail.vue"), meta: {title: '新闻公告-国资智采'}},
            {path: '/ourself', name: "OurSelf", component: () => import("@/views/zhicai/ourSelf.vue"), meta: {title: '关于我们-国资智采'}},
            // {path: '/Bidding',name: "Bidding",component: () => import("@@/views/Bidding/index.vue"),meta: {title: '竞价-国资智采'}},
        ]
    },
    {path:'/login', name:'loginMain', component:()=>import("@/views/zhicai/LoginMain.vue"),meta: {title: '登录-国资智采'}},
    {path:'/PBLoginMain', name:'PBLoginMain', component:()=>import("@/views/zhicai/PBLoginMain.vue"),meta: {title: '专家登录'}},
    {path:'/superviseLogin', name:'SuperviseLogin', component:()=>import("@/views/zhicai/SuperviseLoginMain.vue"),meta: {title: '监督登录'}},
    {path:'/superviseLinks', name:'superviseLinks', component:()=>import("@/views/zhicai/superviseLinks.vue"),meta: {title: '监督/资审通道'}},
    {path:'/register', name:'RegisterMain', component:()=>import("@/views/zhicai/RegisterMain.vue"), meta: {title: '注册-国资智采'}},
    {path:'/marketRegister', name:'marketRegister', component:()=>import("@/views/zhicai/marketRegister.vue"),meta: {title: '业务协同平台注册-国资智采'}},
    // {path: '/BiddingHall',name: "BiddingHall",component: () => import("@@/views/Bidding/BiddingHall.vue"),meta: {     title: '竞价厅-国资智采' }},
    {path:'*',redirect:'/home'},
    {path:'/eat', name: 'ExtAppTokenHandler', component: () => import("@@/components/ExtAppTokenHandler"),meta: {title: '外部跳转'}},
    {path:'/zone',component: zoneApp,children: [
            {path: 'homeZone', name: 'homeZone', component: () => import("@/views/procurementZone/homeZone.vue"), meta: {title: '采购专区'}},
            {path: 'noticeZone', name: 'noticeZone', component: () => import("@/views/procurementZone/noticeZone.vue"), meta: {title: '交易信息-采购专区'}},
            {path: 'ggDetailZone', name: "ggDetailZone", component: () => import("@/views/procurementZone/ggDetailZone.vue"), meta: {title: '交易信息-详情-采购专区'}},
            {path: 'collectGgDetail', name: "collectGgDetail", component: () => import("@/views/procurementZone/collectGgDetail.vue"), meta: {title: '征集公告-采购专区'}},
            {path: 'downloadZone', name: "downloadZone", component: () => import("@/views/procurementZone/downloadZone.vue"), meta: {title: '下载中心-采购专区'}},
            {path: "ourSelfZone", name: "ourSelfZone", component: () => import("@/views/procurementZone/ourSelfZone.vue"), meta: {title: '关于我们-采购专区'}},
        ]
    },
    {path:'/LoginZone', name:'LoginMainZone', component:()=>import("@/views/procurementZone/LoginMain.vue"), meta: {title: '采购专区-登录'}},
    {path:'/RegisterZone', name:'RegisterMainZone', component:()=>import("@/views/procurementZone/RegisterMain.vue"), meta: {title: '采购专区-注册'}},
    {path: '/vendorRegister', name: 'vendorRegisterMain', component: () => import("@/views/procurementZone/vendorRegisterMain.vue"), meta: {title: '供应商入库-国资智采'}},
]
const router = new VueRouter({
    // 配置URL和组价直接的映射关系
    routes,
    // history模式
    mode: 'history'
})
// 将router对象传入到vue实例中
export default router
